import { TaskParameterTypeEnum } from "../enums";

/**Получение палитры параметра */
export const getTaskParameterPalette = (type: TaskParameterTypeEnum) => {
  switch (type) {
    case TaskParameterTypeEnum.Status:
      return [
        "#CC0000",
        "#660000",
        "#CC5500",
        "#CC8400",
        "#C4A114",
        "#29A329",
        "#5A7340",
        "#009A9A",
        "#56D3CD",
        "#365D6F",
        "#002EB8",
        "#000080",
        "#A656D9",
        "#5D0042",
        "#660080",
        "#CC00CC",
        "#66391A",
        "#8C6900",
        "#7A7A7A",
        "#1D2229",
      ];
    case TaskParameterTypeEnum.Priority:
      return [
        "#FF0000",
        "#800000",
        "#FF6B00",
        "#FFA500",
        "#E8BB1C",
        "#32CD32",
        "#769347",
        "#006400",
        "#00CED1",
        "#4A7B8F",
        "#0033FF",
        "#0000A7",
        "#C371FF",
        "#840057",
        "#8300B1",
        "#FF00FF",
        "#8B4513",
        "#B8860B",
        "#4F4F4F",
        "#272D37",
      ];
    case TaskParameterTypeEnum.Tag:
      return [
        "#FF4D4D",
        "#993333",
        "#FF8C40",
        "#FFB347",
        "#E3C019",
        "#66E066",
        "#8AAA6A",
        "#008B00",
        "#40E0D0",
        "#5C9CB3",
        "#3366FF",
        "#1F1FD1",
        "#D799FF",
        "#B00071",
        "#A020F0",
        "#FF66FF",
        "#A0522D",
        "#D9A520",
        "#696969",
        "#3E4751",
      ];
    case TaskParameterTypeEnum.Difficulty:
      return [
        "#FF6666",
        "#A05252",
        "#FF9966",
        "#FFB366",
        "#DFC165",
        "#66E066",
        "#9CAC82",
        "#339933",
        "#56D3CD",
        "#6A96A6",
        "#4D79FF",
        "#4D4DAF",
        "#BA89FF",
        "#BA89FF",
        "#B36691",
        "#A466CC",
        "#FF80FF",
        "#B4785C",
        "#D1B565",
        "#808080",
        "#555A63",
      ];
  }
};
